import types from 'actions/types'
import {combineReducers} from 'redux'
import viewCompanyDialog from './viewCompanyDialog'
import allocateContactListDialog from './allocateContactListDialog'
import deletePartCategoryDialog from './deletePartCategoryDialog'
import movePartCategoryDialog from './movePartCategoryDialog'
import partCategoryDialog from './partCategoryDialog'
import jobBoardsSetupDialog from '../productionContext/jobBoards/jobBoardSetup'
import setupJobCardDialog from './setupJobCardDialog'
import viewJobCardDialog from './viewJobCardDialog'
import deliveryNoteDialog from './deliveryNoteDialog'
import addItemsToPurchaseOrderDialog from './addItemsToPurchaseOrderDialog'
import opportunityDialog from './opportunityDialog'
import purchaseOrderDialog from './purchaseOrderDialog'
import purchaseOrderReceiveItemsDialog from './purchaseOrderReceiveItemsDialog'
import purchaseOrderMarkPaidDialog from './purchaseOrderMarkPaidDialog'
import purchaseInvoiceDialog from './purchaseInvoiceDialog'
import postContactListDialog from './postContactListDialog'
import postContactDialog from './postContactDialog'
import printTemplateDialog from './printTemplateDialog'
import sendEmailDialog from './sendEmailDialog'
import addUserDialog from './addUserDialog'
import addExternalUserDialog from './addExternalUserDialog'
import chartDialog from './chartDialog'
import addBulkInvoicesDialog from './addBulkInvoicesDialog'

const createDialogReducer = (showType, hideType, loadSuccessType) => {

  const visible = (state = false, action) => {
    switch (action.type) {
      case showType:
        return true
      case hideType:
        return false
      default:
        return state
    }
  }

  const data = (state = null, action) => {
    switch (action.type) {
      case showType:
        return action.data
      case hideType:
        return null
      default:
        return state
    }
  }

  const isLoaded = (state = null, action) => {
    switch (action.type) {
      case loadSuccessType:
        return true
      case hideType:
        return false
      default:
        return state
    }
  }

  return combineReducers({
    visible,
    data,
    isLoaded,
  })
}

const createActivityDialogReducer = (
  showType,
  hideType,
  loadSuccessType,
  editActivityUpdateSuccessType,
  editActivitySuccessType,
  addActivitySuccessType,
  loadAttemptType
) => {

  const visible = (state = false, action) => {
    switch (action.type) {
      case showType:
        return true
      case hideType:
        return false
      default:
        return state
    }
  }

  const data = (state = null, action) => {
    switch (action.type) {
      case showType:
        return action.data
      case hideType: {
        return null
      }
      case editActivityUpdateSuccessType:
        const s = Object.assign({}, state)

        s.activity.activityUpdates = state.activity.activityUpdates.map((x) => {
          const {result} = action.data
          if (x.id === result.id) {
            x.timeSpent = result.timeSpent
            x.comment = result.comment
          }
          return x
        })
        return s
      case loadSuccessType:
        return action.activity
      default:
        return state
    }
  }

  const isLoaded = (state = false, action) => {
    switch (action.type) {
      case loadAttemptType:
        return false
      case loadSuccessType:
        return true
      case hideType:
        return false
      default:
        return state
    }
  }

  return combineReducers({
    visible,
    data,
    isLoaded,
  })
}

export const emailApprovalDialog = createDialogReducer(
  types.SHOW_EMAIL_APPROVAL_DIALOG,
  types.HIDE_EMAIL_APPROVAL_DIALOG)

export const deletePartsPrompt = createDialogReducer(types.SHOW_DELETE_PARTS_PROMPT, types.HIDE_DELETE_PARTS_PROMPT)

export const partUsedInPricingCalculatorPrompt = combineReducers({
  visible: (state = false, action) => {
    switch (action.type) {
      case types.SHOW_PART_USED_IN_PRICING_CALCULATOR_PROMPT:
        return true
      case types.HIDE_PART_USED_IN_PRICING_CALCULATOR_PROMPT:
        return false
      default:
        return state
    }
  },
  data: (state = null, action) => {
    return action.type === types.SHOW_PART_USED_IN_PRICING_CALCULATOR_PROMPT ? action.data : state
  },
})

export default combineReducers({
  contact: createDialogReducer(types.SHOW_CONTACT_DIALOG, types.HIDE_CONTACT_DIALOG),
  company: createDialogReducer(types.SHOW_COMPANY_DIALOG, types.HIDE_COMPANY_DIALOG),
  addApproval: createDialogReducer(types.SHOW_ADD_APPROVAL_DIALOG, types.HIDE_ADD_APPROVAL_DIALOG),
  addQuote: createDialogReducer(types.SHOW_ADD_QUOTE_DIALOG, types.HIDE_ADD_QUOTE_DIALOG),
  addInvoice: createDialogReducer(types.SHOW_ADD_INVOICE_DIALOG, types.HIDE_ADD_INVOICE_DIALOG),
  activity: createActivityDialogReducer(types.SHOW_ACTIVITY_DIALOG, types.HIDE_ACTIVITY_DIALOG,
    types.DIALOG_LOAD_ACTIVITY_SUCCESS, types.DIARY_EDIT_ACTIVITY_UPDATE_SUCCESS,
    types.DIARY_EDIT_ACTIVITY_SUCCESS, types.DIARY_ADD_ACTIVITY_SUCCESS,
    types.DIALOG_LOAD_ACTIVITY_ATTEMPT),
  deliveryTypeNoteDialog: createDialogReducer(
    types.SHOW_DELIVERY_TYPE_NOTE_DIALOG,
    types.HIDE_DELIVERY_TYPE_NOTE_DIALOG),
  delivery: createDialogReducer(
    types.DELIVERIES_SHOW_DELIVERY_DIALOG,
    types.DELIVERIES_HIDE_DELIVERY_DIALOG),
  addBulkInvoices: addBulkInvoicesDialog,
  viewCompany: viewCompanyDialog,
  allocateContactList: allocateContactListDialog,
  deletePartCategory: deletePartCategoryDialog,
  deletePartsPrompt,
  partUsedInPricingCalculatorPrompt,
  movePartCategory: movePartCategoryDialog,
  partCategory: partCategoryDialog,
  jobBoardsSetup: jobBoardsSetupDialog,
  setupJobCard: setupJobCardDialog,
  viewJobCard: viewJobCardDialog,
  deliveryNote: deliveryNoteDialog,
  addItemsToPurchaseOrder: addItemsToPurchaseOrderDialog,
  opportunity: opportunityDialog,
  purchaseOrder: purchaseOrderDialog,
  purchaseOrderReceiveItems: purchaseOrderReceiveItemsDialog,
  purchaseOrderMarkPaid: purchaseOrderMarkPaidDialog,
  purchaseInvoice: purchaseInvoiceDialog,
  postContactList: postContactListDialog,
  postContact: postContactDialog,
  printTemplate: printTemplateDialog,
  sendEmailDialog,
  addUserDialog,
  addExternalUserDialog,
  chartDialog,
  deliveryActualTimesDialog: createDialogReducer(
    types.SHOW_DELIVERY_ACTUAL_TIMES_DIALOG,
    types.HIDE_DELIVERY_ACTUAL_TIMES_DIALOG
  ),
  emailApprovalDialog,
})
